import { ApplicationInsights, SeverityLevel } from "@microsoft/applicationinsights-web";
export const AppInsightsConnectionStringKey = "ai_connection_string";
class AppInsights {
    private appInsights: ApplicationInsights | null = null;
    constructor() {
        const enabledUserTracking = this.getCookies()["cookieconsent_status"] === "allow";
        this.InitializeAppInsights(enabledUserTracking);
    }

    public TrackExcepton(message: string) {
        if (this.appInsights?.core.isInitialized) {
            this.appInsights.trackException({ exception: new Error(message), severityLevel: SeverityLevel.Warning, properties: { Toast: "Error" } });
        } 
    }
    public SetUserTrackingConsent(enabledUserTracking: boolean) {
        if (this.appInsights?.core.isInitialized) {
            if(!enabledUserTracking){
                this.appInsights.getCookieMgr().purge("ai_user")
                this.appInsights.getCookieMgr().purge("ai_session")
            }
            // Re-initialize App Insights to apply the user tracking settings
            this.InitializeAppInsights(enabledUserTracking);
        }
    }

    private InitializeAppInsights(enableUserTacking: boolean) {
        const cookies = this.getCookies();
        const appInsightsConnectionString = cookies[AppInsightsConnectionStringKey];
        if (!appInsightsConnectionString) {
            return;
        }
        const ai = new ApplicationInsights({
            config: {
                connectionString: appInsightsConnectionString,
                disableCookiesUsage: !enableUserTacking,
                isStorageUseDisabled: !enableUserTacking,
                // disableUserInitMessage: true // should be set to true after App Insights JS SDK 3.1 is released 
                // now this generates a extra entry for every time the user cookie is created. For normal users with cookies allowed it's okey as it's one message per year
                // For users with cookies disabled it's one message per page load
            }
        })
        ai.loadAppInsights();
        ai.trackPageView();
        this.appInsights = ai;
    }

    private getCookies() {
        const cookies: { [key: string]: string } = {};
        for (const cookie of document.cookie.split("; ")) {
            const [name, value] = cookie.split("=");
            cookies[name] = decodeURIComponent(value);
        }
        return cookies;
    }
}
export default new AppInsights();
